
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../../controlador';
    import notaventa from './resumen-menu-archivos-nota.vue';
    import mercadopago from './resumen-menu-archivos-nota-mercadopago.vue';
    import presupuesto from './resumen-menu-archivos-presupuesto.vue';
    import etiquetaenvio from './resumen-menu-archivos-etiqueta-envio.vue';
    import declaracion from './resumen-menu-archivos-declaracion.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: {
            notaventa,
            presupuesto,
            mercadopago,
            etiquetaenvio,
            declaracion,
        }
    } )
    export default class Componente extends Vue
    {

        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get SubModo() { return this.Controlador.Vista.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.Controlador.Vista.BarraDerecha.SubModo = x; }
        public get Modo() { return this.Controlador.Vista.BarraDerecha.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.BarraDerecha.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }


        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.BarraDerecha.onSubModo.subscribe( () =>
            {
                if ( this.SubModo == 'archivos' )
                {
                    this.Controlador.Vista.BarraDerecha.Anchura.Espacio = 300;
                }
            } ) );

            this.SubModo = 'archivos';
            this.Iniciar();
        }


        public Cargando: boolean = false;
        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {
            this.Cargando = true;

            this.Cargando = false;
        }

        public async Abrir( item: string )
        {
            this.Modo = item;
        }


        Cerrar()
        {
            this.Modo = '';
        }

        public Refresh: boolean = false;
        Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }
    }
